import React, { FunctionComponent } from 'react'

export const CuzkLvHtmlBezZapisuFragment: FunctionComponent = () => {
  return (
    <span>
      {' - '} <strong>Bez zápisu</strong>
    </span>
  )
}
